import React from 'react'
import Header from '../../component/Header'
import Footer from '../../component/Footer'
import Diploma from '../Diploma'
import CourseBsc from '../CourseBsc'

export default function LayoutCourseBSC() {
    return (
        <div>
            <Header />
            <CourseBsc />
            <Footer />
        </div>
    )
}
